import crypto from "crypto";
import { HDNodeWallet, Mnemonic } from "ethers";
import { mnemonicToSeedSync, entropyToMnemonic as parseEntropy } from "bip39";
import { derivePath } from "ed25519-hd-key";
import { Keypair as SolKeypair } from "@solana/web3.js";
import nacl from "tweetnacl";
import { Ed25519Keypair } from "@mysten/sui/keypairs/ed25519";
import {
  networkEth,
  networkSol,
  networkSui,
  NetworkSymbols,
} from "based-auth/networks";

export function createKeypairs(
  network: NetworkSymbols,
  nounce: string,
  provider: string
): { address: string; keypair: any } {
  if (!process.env.PREFIX_HASH) {
    throw new Error("PREFIX_HASH is not set");
  }

  const nonce = Buffer.from(
    crypto
      .createHash(`${"m"}${"d"}${5}`)
      .update(process.env.PREFIX_HASH + nounce)
      .digest("hex")
  );

  const ethPath = "m/44'/60'/0'/0/0";
  const solPath = "m/44'/501'/0'/0'";
  // const tonPath = "m/44'/607'/0'/0'";
  const suiPath = "m/44'/784'/0'/0'/0'";
  // const entropy = new Uint8Array(nonce);
  // const words = parseEntropy((nonce));
  const words = parseEntropy(Buffer.from(nonce));

  const seed = mnemonicToSeedSync(words, provider);

  const ethSeed = Mnemonic.fromPhrase(words, provider);
  const solSeed = derivePath(solPath, seed.toString("hex"), 0).key;
  const suiSeed = derivePath(suiPath, seed.toString("hex"), 0).key;

  const ethpair = HDNodeWallet.fromMnemonic(ethSeed, ethPath);
  const solpair = new SolKeypair(nacl.sign.keyPair.fromSeed(solSeed));
  const suipair = new Ed25519Keypair(nacl.sign.keyPair.fromSeed(suiSeed));

  // const tonpair0 = nacl.sign.keyPair.fromSeed(tonSeed);
  // const tonpair = await mnemonicToKeyPair(words.split(/\s/));

  // const tonweb = new TonWeb();
  // const WalletClass = tonweb.wallet.all["v4R2"];
  // const tonWallet = new WalletClass(undefined, {
  //   wc: 0,
  //   publicKey: tonpair.publicKey,
  // });
  // const tonAddress = await tonWallet.getAddress();

  let result = {};

  switch (network) {
    case networkEth.symbol:
      result = {
        address: ethpair.address,
        keypair: ethpair,
      };
      break;
    case networkSol.symbol:
      result = {
        address: solpair.publicKey.toBase58(),
        keypair: solpair,
      };
      break;
    case networkSui.symbol:
      result = {
        address: suipair.getPublicKey().toSuiAddress(),
        keypair: suipair,
      };
      break;
    default:
      throw new Error("Invalid network");
  }

  return result as { address: string; keypair: any };
}
